import { render, staticRenderFns } from "./GalleryProject.vue?vue&type=template&id=978e8fa8&"
import script from "./GalleryProject.vue?vue&type=script&lang=js&"
export * from "./GalleryProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports